import { defineMessages } from 'react-intl';


export default defineMessages({
    AMOUNT_PLACEHOLDER: {
        id: 'mtg-common.amount.placeholder',
        defaultMessage: '$ Enter amount',
    },
    PERCENT_PLACEHOLDER: {
        id: 'mtg-common.percent.placeholder',
        defaultMessage: '% Enter percentage',
    },
    INLINE_PERCENT_PLACEHOLDER: {
        id: 'mtg-common.percent.inline-placeholder',
        defaultMessage: '%',
    },
    CHOICE_PLACEHOLDER: {
        id: 'mtg-common.choice.placeholder',
        defaultMessage: 'Select an option',
    },
    COMPACT_PERCENT_PLACEHOLDER: {
        id: 'mtg-common.percent.compact-percent-placeholder',
        defaultMessage: 'Down payment $',
    },
});
